import { render, staticRenderFns } from "./CreacionSolicitud.vue?vue&type=template&id=068e0362"
import script from "./CreacionSolicitud.vue?vue&type=script&lang=js"
export * from "./CreacionSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports